import { HttpParams } from '@angular/common/http';

export function buildHttpParams(
  body: Record<string, any> = {},
  options: { skipFalsy?: boolean; skipNullish?: boolean; appendKeys?: string[] } = {}
): HttpParams {
  const { skipFalsy = false, skipNullish = false, appendKeys = [] } = options;
  let params = new HttpParams();

  Object.keys(body).forEach(key => {
    const value = body[key];

    if (appendKeys.includes(key)) {
      value?.forEach(item => {
        params = params.append(key, item);
      });
      return;
    }

    if (skipFalsy && !value) {
      return;
    }

    if (skipNullish && (value == null || value === '')) {
      return;
    }

    params = params.set(key, value);
  });

  return params;
}
